import { getIn } from "formik"
import React from "react"
import { CropFilePicker as JBFilePicker } from "shared/ui/berry-jass-extended"
import { getErrorText } from "./helpers"

const fieldToFilePicker = ({
  disabled,
  field,
  onChange = null,
  form: {
    errors,
    touched,
    isSubmitting,
    setSubmitting,
    setFieldValue,
    setFieldTouched
  },
  ...props
}) => {
  const fieldError = getIn(errors, field.name)
  const showError = getIn(touched, field.name) && !!fieldError

  const {
    onChange: _onChange,
    onBlur: _onBlur,
    multiple: _multiple,
    ...fieldRest
  } = field

  return {
    error: showError,
    helperText: showError ? getErrorText(fieldError) : null,
    disabled: disabled ?? isSubmitting,
    onUploadStart: () => {
      setSubmitting(true)
    },
    onUploadSettled: () => {
      setSubmitting(false)
    },
    onChange: function handleChange(_event, value) {
      if (onChange) {
        onChange(_event, value)
      }

      setFieldValue(field.name, value)
      setFieldTouched(field.name)
    },
    ...fieldRest,
    ...props
  }
}

export const CropFilePicker = (props) => {
  return <JBFilePicker {...fieldToFilePicker(props)} />
}
